import { render, staticRenderFns } from "./GarmentReport.vue?vue&type=template&id=b098673e"
import script from "./GarmentReport.vue?vue&type=script&lang=js"
export * from "./GarmentReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports